export default "__VITE_ASSET__B9vJ4AuZ__"